// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl : 'https://games.bouncycoin.com:8888/',
  // sitekey: '6LcdNo0UAAAAAJRRVuky5zYFf51-5FRGBYtIVMM_'
  sitekey: '6LfEOMQUAAAAAKddHrK2UrK3S_3TemBrVmnwFJLU',
  contestStartDate: new Date('2019/12/20 00:00:00'), // yyyy/mm/dd hh:MM:ss
  contestEndDate: new Date('2030/02/01 00:00:00') // yyyy/mm/dd hh:MM:ss
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
